import type { FC } from "react";

import { ImageInfoBanner as UIImageInfoBanner } from "@jti/loyalty/components/ImageInfoBanner";

import type { imageInfoBannerInputs } from "./ImageInfoBanner.builder";

import styles from "./ImageInfoBanner.module.scss";

type ImageInfoBannerBuilderProps = BuilderComponentProps<typeof imageInfoBannerInputs>;

export const ImageInfoBanner: FC<ImageInfoBannerBuilderProps> = (props) => {
  return (
    // Dirty hack to make components 100% height when they exists with sibling of bigger height,
    // in AEM this component was placed in Loyalty Container which we do not support in builder, this container used flex box which enabled its children to match height
    // so now it will either have its of 100% height or match height of sibling component
    // once DS implementation for this component is finished we should not have this problem anymore
    <div className={styles.builderWrapper}>
      <UIImageInfoBanner {...props} />
    </div>
  );
};
